import React, { FC } from 'react'
import { createUseStyles } from 'react-jss'
import { SpreadsheetIcon } from '../../icons/spreadsheet-icon/SpreadsheetIcon'
import { StyledIcon } from '../../styled-icon/StyledIcon'

type StyledSpreadhsheetIconProps = {}

export const StyledSpreadhsheetIcon: FC<StyledSpreadhsheetIconProps> = () => {

	// hooks
	const styles = useStyles()

	return (
		<StyledIcon
			icon={SpreadsheetIcon}
			colors={{
				background: '#D16B3D',
				foreground: '#FFF9F7',
			}}
		/>
	)
}

const useStyles = createUseStyles({
	styledSpreadhsheetIcon: {
		display: 'grid'
	}
})